/**todo: currently amount is price, need to change amount to price and then change numberOfPurchase to amount
 *       also, current Symbol is currency, change that and so symbol is symbol(stockSymbol), currency is currency **/

import { Component, model, ModelSignal } from "@angular/core";
import { editTransactionTab } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/edit-transaction-details/edit-transaction-details.component";

@Component({
  selector: "app-tabs-wrapper",
  templateUrl: "./tabs-wrapper.component.html",
})
export class TabsWrapperComponent {
  protected tabActive: ModelSignal<string> = model("");

  protected tabs = Object.values(editTransactionTab);
  onTabClick(tab: string) {
    this.tabActive.set(tab);
  }
}
